<template>
  <div>
    <ContentHeader title="Details" />
    <r-detail-skeleton v-if="loading"></r-detail-skeleton>
    <section v-else class="content">
      <div class="container-fluid">
        <div
          class="alert alert-warning w-100"
          role="alert"
          v-if="
            (!robot.selling_price && robot.risk_level == 0) ||
            robot.risk_level == null
          "
        >
          Robot anda sedang dilakukan peninjauan oleh admin.
        </div>
      </div>
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="col-md-4 d-flex justify-content-center align-items-center"
              >
                <img
                  class="detail-image"
                  :src="robot.image"
                  alt="User profile picture"
                />
              </div>
              <div class="col-md-8 info-detail">
                <h3 class="font-weight-bold">
                  {{ robot.name ? robot.name : "-" }}
                </h3>
                <h5>Vendor Name</h5>
                <p class="pl-1">{{ vendor.name ? vendor.name : "-" }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card m-md-3">
          <div class="card-body">
            <div class="tab-content">
              <div class="row mb-3">
                <div class="col-md-6">
                  <h3>Risk Level</h3>
                  <h5 class="text-danger" v-if="robot.risk_level == null">
                    RISK NOT SET
                  </h5>
                  <h5 class="text-success" v-else-if="robot.risk_level == 1">
                    LOW
                  </h5>
                  <h5 class="text-warning" v-else-if="robot.risk_level == 2">
                    MEDIUM
                  </h5>
                  <h5 class="text-danger" v-else>HIGH</h5>
                </div>
                <div class="col-md-6">
                  <h3>Trade Report File</h3>
                  <a
                    v-if="robot.trade_report_file"
                    :href="`${robot.trade_report_file}`"
                    download
                    class="btn btn-outline-success rounded-pill px-md-5"
                  >
                    Download
                  </a>
                  <button v-else class="btn btn-outline-danger rounded-pill">
                    No File Uploaded
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="ps-0">
                    <h3>Recommended Lot Size</h3>
                    <div
                      v-if="recommendedData.lotSize.length > 0"
                      class="d-flex pb-2 align-items-between gap-2"
                    >
                      <div
                        class="col col-md-6 d-flex ps-0 gap-3 card-container"
                      >
                        <div
                          class="card card-res text-white bg-dark"
                          style="width: 100px"
                          v-for="(lot, index) in recommendedData.lotSize"
                          :key="index"
                        >
                          <span
                            class="flex d-flex gap-2 align-items-center justify-content-center"
                          >
                            <p class="m-2">
                              <span>{{ `${lot.lot} %` }}</span>
                            </p>
                            <i
                              class="fas fa-times pe-2"
                              style="color: #dc3545"
                              @click="deleteLotSize(lot.lot)"
                            ></i>
                          </span>
                        </div>
                        <!-- <div class="card-deck">
                        </div> -->
                      </div>
                      <button
                        type="button"
                        class="btn btn-outline-dark px-2 mb-3"
                        data-toggle="modal"
                        data-target="#modalInput"
                        @click="modalActivate('Lot Size')"
                      >
                        Add / Update Data
                      </button>
                    </div>
                    <button
                      v-else
                      type="button"
                      class="btn btn-outline-dark px-2 mb-3"
                      data-toggle="modal"
                      data-target="#modalInput"
                      @click="modalActivate('Lot Size')"
                    >
                      Add / Update Data
                    </button>
                  </div>
                </div>
                <div class="col-md-6">
                  <h3 class="">Description</h3>
                  <p class="m-0">
                    {{ robot.description }}
                  </p>
                </div>
                <div class="col-md-6 pt-2">
                  <div class="ps-0">
                    <h3>Recommended Active Pair</h3>
                    <div
                      v-if="recommendedData.activePair.length > 0"
                      class="d-flex pb-2 align-items-between gap-2"
                    >
                      <div
                        class="col col-md-6 d-flex ps-0 gap-3 card-container"
                      >
                        <div
                          class="card card-res border-1 border-dark"
                          style="width: 180px"
                          v-for="(pair, index) in recommendedData.activePair"
                          :key="index"
                        >
                          <span
                            class="flex d-flex gap-1 align-items-center justify-content-between"
                          >
                            <span class="mb-2">
                              <p class="my-0 ms-2 mt-2">
                                <span
                                  ><b>{{ pair.active_pair }}</b></span
                                >
                              </p>
                              <small class="ms-2"
                                >Min. Deposit :
                                <b>${{ pair.minimum_deposit }}</b></small
                              >
                            </span>
                            <i
                              class="fas fa-times pe-2"
                              @click="deleteActivePair(pair.active_pair)"
                              style="color: #dc3545"
                            ></i>
                          </span>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn btn-outline-dark px-2 mb-3"
                        data-toggle="modal"
                        data-target="#modalInput"
                        @click.prevent="modalActivate('Active Pair')"
                      >
                        Add / Update Data
                      </button>
                    </div>
                    <button
                      type="button"
                      class="btn btn-outline-dark px-2 mb-3"
                      v-else
                      data-toggle="modal"
                      data-target="#modalInput"
                      @click="modalActivate('Active Pair')"
                    >
                      Add / Update Data
                    </button>
                  </div>
                </div>
                <div class="col-md-6">
                  <h3 class="">Robot Type</h3>
                  <p>{{ robot.type ? robot.type : "-" }}</p>
                </div>
                <div class="col-md-6 pt-2">
                  <h3 class="">Recommended Pair Option</h3>
                  <div
                    v-if="recommendedData.pairOption.length > 0"
                    class="d-flex pb-2 align-items-between gap-2"
                  >
                    <div class="col col-md-6 d-flex ps-0 gap-3 card-container">
                      <div
                        class="card card-res text-white bg-dark"
                        style="width: 180px"
                        v-for="(pair, index) in recommendedData.pairOption"
                        :key="index"
                      >
                        <span
                          class="flex d-flex gap-1 align-items-center justify-content-between"
                          v-if="recommendedData.pairOption.length > 0"
                        >
                          <span class="mb-2">
                            <p class="my-0 ms-2 mt-2">
                              <span
                                ><b>{{
                                  index + 1 ? pair.symbol : `${pair.symbol}, `
                                }}</b></span
                              >
                            </p>
                            <small class="ms-2"
                              >Min. Deposit :
                              <b>${{ pair.minimum_deposit }}</b></small
                            >
                          </span>
                          <i
                            class="fas fa-times pe-2"
                            style="color: #dc3545"
                            @click="deletePairOption(pair.symbol)"
                          ></i>
                        </span>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-outline-dark px-2 mb-3"
                      data-toggle="modal"
                      data-target="#modalInput"
                      @click="modalActivate('Pair Options')"
                    >
                      Add / Update Data
                    </button>
                  </div>
                  <button
                    v-else
                    type="button"
                    class="btn btn-outline-dark px-2 mb-3"
                    data-toggle="modal"
                    data-target="#modalInput"
                    @click="modalActivate('Pair Options')"
                  >
                    Add / Update Data
                  </button>
                </div>

                <div class="col-md-6">
                  <h3 class="">Strategy</h3>
                  <p v-html="details[0] ? details[0] : '-'"></p>
                </div>
                <div class="col-md-6">
                  <h3 class="">Trade Report Url</h3>
                  <a :href="robot.trade_report_url" target="_blank">
                    {{ robot.trade_report_url }}
                  </a>
                </div>
                <div class="col-md-6">
                  <h3 class="">Basic Price</h3>
                  <p>
                    Rp
                    {{
                      new Intl.NumberFormat("id-ID").format(
                        Number(parseInt(robot.basic_price)).toFixed()
                      )
                    }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <h3>Installation video url</h3>
                  <a
                    v-if="robot.installation_video_url"
                    :href="robot.installation_video_url"
                    target="_blank"
                  >
                    {{ robot.installation_video_url }}
                  </a>
                  <p v-else class="text-secondary">No installation video set</p>
                </div>
                <div class="col-md-6" v-if="robot.selling_price">
                  <h3 class="">Selling Price</h3>
                  <p>
                    Rp
                    {{
                      new Intl.NumberFormat("id-ID").format(
                        Number(parseInt(robot.selling_price)).toFixed()
                      )
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card broker m-md-3">
          <div class="container-fluid pt-3 ml-2">
            <h4>Choose Broker</h4>
          </div>
          <div class="card-header">
            <!-- <router-link
              :to="{ name: 'AddBroker', param: { id: robot.id } }"
              class="btn btn-success rounded-pill add-button"
              ><i class="fas fa-plus"></i>Add Broker</router-link
            >

            <div class="d-flex filter-container">
              <select
                class="form-select w-25 select-perpage mr-3"
                v-model="table.perPage"
              >
                <option value="4">4</option>
                <option value="10" selected>10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
              <input
                type="text"
                name="search"
                class="form-control w-75 search-bar"
                placeholder="Search"
                v-model="table.filter"
              />
            </div>
          </div>
          <div class="card-body table-responsive p-0">
            <b-table
              hover
              :items="brokers"
              :fields="table.fields"
              :current-page="table.currentPage"
              :per-page="table.perPage"
              :filter="table.filter"
              @filtered="onFiltered"
              show-empty
              responsive
            >
              <template #empty="scope">
                <p class="text-center">
                  {{ scope.emptyText }}
                </p>
              </template>
              <template #emptyFiltered="scope">
                <p class="text-center">
                  {{ scope.emptyFilteredText }}
                </p>
              </template>
              <template #cell(No)="data">
                {{ (table.currentPage - 1) * table.perPage + data.index + 1 }}
              </template>
              <template v-slot:cell(is_active)="data">
                <i
                  v-if="data.item.is_active"
                  class="fas fa-check-circle text-success"
                  style="font-size: 1.5rem"
                ></i>
                <i
                  v-else
                  class="fas fa-times-circle text-danger"
                  style="font-size: 1.5rem"
                ></i>
              </template>
              <template v-slot:cell(Action)="data">
                <router-link
                  :to="{
                    name: 'UpdateBroker',
                    params: { id: data.item.id },
                  }"
                >
                  <i class="fas fa-edit text-warning"></i>
                </router-link>
              </template>
            </b-table>
          </div>
          <b-pagination
            v-model="table.currentPage"
            :total-rows="table.totalRows"
            :per-page="table.perPage"
            class="my-0 p-3"
          ></b-pagination> -->
            <div class="row w-100">
              <div
                class="col-lg-3"
                v-for="broker in filterBrokers"
                :key="broker.id"
              >
                <div class="broker-list">
                  <input
                    type="checkbox"
                    name="broker"
                    @click="toggleBrokerSelection(broker.id, $event.target.checked)"
                    :id="'broker' + broker.id"
                  />
                  <label :for="'broker' + broker.id" class="broker-body">
                    <!-- <div class="broker-body"> -->
                    <div class="check_img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 35.294 35.294"
                      >
                        <g id="check_icon" transform="translate(-440 -366)">
                          <path
                            id="Path_395"
                            data-name="Path 395"
                            d="M8.585,0H26.709a8.585,8.585,0,0,1,8.585,8.585V26.709a8.585,8.585,0,0,1-8.585,8.585H8.585A8.585,8.585,0,0,1,0,26.709V8.585A8.585,8.585,0,0,1,8.585,0Z"
                            transform="translate(440 366)"
                            fill="#ed1c24"
                          />
                          <path
                            id="Icon_awesome-check"
                            data-name="Icon awesome-check"
                            d="M6.588,18.758l-6.3-6.3a.97.97,0,0,1,0-1.372L1.656,9.711a.97.97,0,0,1,1.372,0l4.247,4.247,9.1-9.1a.97.97,0,0,1,1.372,0l1.372,1.372a.97.97,0,0,1,0,1.372L7.96,18.758A.97.97,0,0,1,6.588,18.758Z"
                            transform="translate(447.631 371.916)"
                            fill="#fff"
                          />
                        </g>
                      </svg>
                    </div>
                    <figure>
                      <img :src="broker.logo" class="broker-img" alt="" />
                    </figure>
                    <p class="text-center">{{ broker.name }}</p>
                    <button
                      type="button"
                      class="linkbroker"
                      data-toggle="modal"
                      data-target="#modalBroker"
                      @click="brokerdetail(broker)"
                    >
                      Detail
                    </button>
                    <div
                      class="modal fade"
                      id="modalBroker"
                      data-backdrop="static"
                      data-keyboard="false"
                      tabindex="-1"
                      aria-labelledby="staticBackdropLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-body modalbroker">
                            <div>
                              <h3>Detail Broker</h3>
                              <span class="badge badge-danger"
                                >Reccomended
                              </span>
                              <div class="d-flex headdetailbroker mt-1">
                                <figure>
                                  <img :src="brokerdata.logo" alt="" />
                                </figure>
                                <div class="deskripsi-head">
                                  <small>
                                    {{ brokerdata.company_name }}
                                  </small>
                                  <h5>{{ brokerdata.name }}</h5>
                                  <p>
                                    {{ brokerdata.type }} |
                                    {{ brokerdata.country }}
                                  </p>
                                </div>
                              </div>
                              <h6 class="mt-3">Telephone</h6>
                              <p class="pl-2">{{ brokerdata.phone }}</p>
                              <h6 class="mt-2">Email</h6>
                              <p class="pl-2">{{ brokerdata.email }}</p>
                              <h6 class="mt-2">Deskripsi</h6>
                              <div
                                class="pl-2"
                                v-if="brokerdata.description"
                                v-html="brokerdata.description"
                              ></div>
                              <div class="pl-2" v-if="!brokerdata.description">
                                -
                              </div>
                            </div>
                            <div class="bottommodal">
                              <small>Regulated by bappebti</small>
                              <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                              >
                                Close
                              </button>
                              <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                              <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- </div> -->
                  </label>
                </div>
              </div>
              <div
                class="col-lg-3"
                v-for="broker in brokerActive"
                :key="broker.id"
              >
                <div class="broker-list">
                  <input
                    type="checkbox"
                    name="broker"
                    @click="toggleBroker(broker.id, $event.target.checked)"
                    checked
                    :id="'broker' + broker.id"
                  />
                  <label :for="'broker' + broker.id" class="broker-body">
                    <!-- <div class="broker-body"> -->
                    <div class="check_img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 35.294 35.294"
                      >
                        <g id="check_icon" transform="translate(-440 -366)">
                          <path
                            id="Path_395"
                            data-name="Path 395"
                            d="M8.585,0H26.709a8.585,8.585,0,0,1,8.585,8.585V26.709a8.585,8.585,0,0,1-8.585,8.585H8.585A8.585,8.585,0,0,1,0,26.709V8.585A8.585,8.585,0,0,1,8.585,0Z"
                            transform="translate(440 366)"
                            fill="#ed1c24"
                          />
                          <path
                            id="Icon_awesome-check"
                            data-name="Icon awesome-check"
                            d="M6.588,18.758l-6.3-6.3a.97.97,0,0,1,0-1.372L1.656,9.711a.97.97,0,0,1,1.372,0l4.247,4.247,9.1-9.1a.97.97,0,0,1,1.372,0l1.372,1.372a.97.97,0,0,1,0,1.372L7.96,18.758A.97.97,0,0,1,6.588,18.758Z"
                            transform="translate(447.631 371.916)"
                            fill="#fff"
                          />
                        </g>
                      </svg>
                    </div>
                    <figure>
                      <img :src="broker.logo" class="broker-img" alt="" />
                    </figure>
                    <p class="text-center">{{ broker.name }}</p>
                    <button
                      type="button"
                      class="linkbroker"
                      data-toggle="modal"
                      data-target="#modalBrokerActive"
                      @click="brokerdetail(broker)"
                    >
                      <u>Detail</u>
                    </button>
                    <div
                      class="modal fade"
                      id="modalBrokerActive"
                      data-backdrop="static"
                      data-keyboard="false"
                      tabindex="-1"
                      aria-labelledby="staticBackdropLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-body modalbroker">
                            <div>
                              <h3>Detail Broker</h3>
                              <!-- <span class="badge badge-danger"
                                >Reccomended
                              </span> -->
                              <div class="d-flex headdetailbroker mt-1">
                                <figure>
                                  <img :src="brokerdata.logo" alt="" />
                                </figure>
                                <div class="deskripsi-head">
                                  <small>
                                    {{ brokerdata.company_name }}
                                  </small>
                                  <h5>{{ brokerdata.name }}</h5>
                                  <p>
                                    {{ brokerdata.type }} |
                                    {{ brokerdata.country }}
                                  </p>
                                </div>
                              </div>
                              <h6 class="mt-3">Telephone</h6>
                              <p class="pl-2">{{ brokerdata.phone }}</p>
                              <h6 class="mt-2">Email</h6>
                              <p class="pl-2">{{ brokerdata.email }}</p>
                              <h6 class="mt-2">Deskripsi</h6>
                              <div
                                class="pl-2"
                                v-if="brokerdata.description"
                                v-html="brokerdata.description"
                              ></div>
                              <div class="pl-2" v-if="!brokerdata.description">
                                -
                              </div>
                            </div>
                            <div class="bottommodal">
                              <small>Regulated by bappebti</small>
                              <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                              >
                                Close
                              </button>
                              <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                              <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- </div> -->
                  </label>
                </div>
              </div>
              <p v-if="filterBrokers.length == 0 && brokerActive.length == 0">
                No Broker available.
              </p>
            </div>
            <div class="">
              <button
                type="button"
                :disabled="
                  brokers.length == 0
                "
                class="btn btn-danger my-2"
                @click="saveBrokerSelection"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="modalInput"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <div class="flex justify-start">
                <h4 class="modal-title" id="exampleModalLabel">
                  {{ dataOptions }}
                </h4>
                <span class="badge badge-danger style-badge d-flex">
                  <small class="my-1">The same active data will updated</small>
                </span>
              </div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <!-- Lot Size -->
            <div v-if="dataOptions == 'Lot Size'" class="modal-body">
              <div>
                <div class="form-group">
                  <label for="name">{{ dataOptions }} (%)</label>
                  <input
                    type="text"
                    class="form-control"
                    id="lotSize"
                    placeholder="ex: 1, or 2"
                    v-model="dataInput.lotSize.lotSize"
                  />
                  <div
                    class="text-danger"
                    v-if="$v.dataInput.lotSize.lotSize.$error"
                  >
                    <small>{{
                      $v.dataInput.lotSize.lotSize.required
                        ? `
                                  ${$v.dataInput.lotSize.lotSize.$params.numeric.type} characters only`
                        : "Lot Size is Required"
                    }}</small>
                  </div>
                </div>
                <div class="bottommodal">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="addLotSize"
                  >
                    Add to {{ dataOptions }}
                  </button>
                  <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                  <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                </div>
              </div>
            </div>
            <!-- Active Pair -->
            <div v-if="dataOptions == 'Active Pair'" class="modal-body">
              <div>
                <div class="form-group">
                  <label for="symbol">Pair Symbol</label>
                  <multiselect
                    v-model="dataInput.activePair.pairOption"
                    :options="pairOptions.map((item) => item)"
                  >
                  </multiselect>
                  <div
                    class="text-danger"
                    v-if="$v.dataInput.activePair.pairOption.$error"
                  >
                    <small>Select at least 1 Active Pair</small>
                  </div>
                </div>
                <div class="form-group">
                  <label for="deposit">Minimum Deposit</label>
                  <div class="input-group">
                  <span class="input-group-text">$</span>
                  <input
                    type="text"
                    class="form-control"
                    :class="{
                      'border-danger': $v.dataInput.activePair.deposit.$error,
                    }"
                    id="deposit"
                    placeholder="3000"
                    v-model="dataInput.activePair.deposit"
                  />
                  </div>

                  <div
                    class="text-danger"
                    v-if="$v.dataInput.activePair.deposit.$error"
                  >
                    <small>{{
                      $v.dataInput.activePair.deposit.required
                        ? `
                                  ${$v.dataInput.activePair.deposit.$params.numeric.type} characters only`
                        : "Deposit Amount is Required"
                    }}</small>
                  </div>
                </div>
                <div class="bottommodal">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="addActivePair"
                  >
                    Add to {{ dataOptions }}
                  </button>
                  <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                  <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                </div>
              </div>
            </div>
            <!-- Pair Options -->
            <div v-if="dataOptions == 'Pair Options'" class="modal-body">
              <div>
                <div class="form-group">
                  <label for="pairOption">Pair Symbol</label>
                  <input
                    type="text"
                    class="form-control"
                    :class="{
                      'border-danger': $v.dataInput.pairOption.symbol.$error,
                    }"
                    id="symbol"
                    placeholder="Ex: EURUSD / CADJPY"
                    v-model="dataInput.pairOption.symbol"
                  />
                  <div
                    class="text-danger"
                    v-if="$v.dataInput.pairOption.symbol.$error"
                  >
                    <small>{{
                      $v.dataInput.pairOption.symbol.required
                        ? `Maximum length is
                                ${$v.dataInput.pairOption.symbol.$params.maxLength.max} characters`
                        : "Pair Symbol is Required"
                    }}</small>
                  </div>
                </div>
                <div class="form-group">
                    <label for="deposit">Minimum Deposit</label>
                    <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                        type="text"
                        class="form-control"
                        :class="{
                            'border-danger': $v.dataInput.pairOption.deposit.$error,
                        }"
                        id="deposit"
                        placeholder="3000"
                        v-model="dataInput.pairOption.deposit"
                        />

                    </div>
                    <div
                        class="text-danger"
                        v-if="$v.dataInput.pairOption.deposit.$error"
                    >
                        <small>
                            {{
                            $v.dataInput.pairOption.deposit.required
                            ? `
                                    ${$v.dataInput.pairOption.deposit.$params.numeric.type} characters only`
                            : "Deposit Amount is Required"
                            }}
                        </small>
                    </div>
                </div>
                <div class="bottommodal">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="addPairOption"
                  >
                    Add to {{ dataOptions }}
                  </button>
                  <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                  <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RDetailSkeleton from "@/components/loading-screen/RDetailSkeleton.vue";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiClient from "../../services/ApiServices";
import apiBroker from "../../services/BrokerApiServices";
import swal from "sweetalert";
import Multiselect from "vue-multiselect";
import $ from "jquery";
import { required, maxLength, numeric, minValue } from "vuelidate/lib/validators";
import Vue from "vue";

export default {
  components: {
    ContentHeader,
    RDetailSkeleton,
    Multiselect,
  },
  data() {
    return {
      loading: true,
      robot: {
        vendor: {
          name: "",
        },
      },
      recommendedData: {
        lotSize: [],
        activePair: [],
        pairOption: [],
      },
      dataOptions: "",
      dataInput: {
        lotSize: {
          lotSize: "",
        },
        activePair: {
          pairOption: "",
          deposit: "",
        },
        pairOption: {
          symbol: "",
          deposit: "",
        },
      },
      pairOptions: ["SINGLE", "DOUBLE", "MULTI"],
      submitted: false,
      brokerdata: [],
      brokerActivedata: [],
      brokercheck: [],
      brokers: [],
      selectedBrokers: [],
      details: [],
      listbroker: [],
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {
            key: "account_number",
            sortable: true,
          },
          {
            key: "broker_server",
            sortable: true,
          },
          {
            key: "is_active",
            label: "Status",
            sortable: true,
          },
          "Action",
        ],
      },
    };
  },
  async mounted() {
    try {
      this.loading = true;

      this.fetchUpdateData();
      let robot = await apiClient.get(`${this.$route.params.id}/`);
      this.robot = robot.data.data;
      this.robot.id = `${this.robot.id}`;

      let brokercheck = await apiClient.get(
        `broker/?robot=${this.$route.params.id}`
      );
      this.brokercheck = brokercheck.data.data;
      this.brokercheck.forEach((item) => {
        this.listbroker.push(item.broker_id);
        this.brokerActivedata.push(item.broker_id);
      });
      let databroker = await apiBroker.get(`/`);

      this.brokers = databroker.data.data;
      this.table.totalRows = this.brokers.length;
    } catch (error) {
      this.$toasted.show(error.message, {
        theme: "toasted-primary",
        position: "top-right",
        duration: 4000,
      });
    } finally {
      this.loading = false;
    }

    if (this.robot.strategy !== "") {
      this.details = this.robot.strategy.split(";");
    }
  },
  computed: {
    vendor() {
      return this.robot.vendor;
    },
    filterBrokers() {
      let brokerfilter = this.brokers.filter(
        (brokeritem) => brokeritem.is_active == true
      );
      brokerfilter = brokerfilter.filter(
        (ar) => !this.brokercheck.find((rm) => rm.broker_id === ar.id)
      );
      return brokerfilter;
    },
    brokerActive() {
      console.log("masuk");
      let brokeractive = this.brokers.filter(
        (brokeritem) => brokeritem.is_active == true
      );
      brokeractive = brokeractive.filter((ar) =>
        this.brokercheck.find((rm) => rm.broker_id === ar.id)
      );
      return brokeractive;
    },
  },
  methods: {
    modalActivate(data) {
      return (this.dataOptions = data);
    },
    async fetchUpdateData() {
      try {
        let lotSize = await apiClient.get(
          `/${this.$route.params.id}/lot-sizes/`
        );
        let activePair = await apiClient.get(
          `/${this.$route.params.id}/active-pairs/`
        );
        let pairOption = await apiClient.get(
          `/${this.$route.params.id}/pair-options`
        );
        this.recommendedData.lotSize = lotSize?.data.data;
        this.recommendedData.activePair = activePair?.data.data;
        this.recommendedData.pairOption = pairOption?.data.data;
      } catch (error) {
        Vue.swal.fire({
          icon: "error",
          title: "Oops... Something went wrong! ",
          text: `${error.message}`,
          showConfirmButton: true,
          confirmButtonColor: "#000000",
        });
      }
    },
    async addLotSize() {
      this.$v.dataInput.lotSize.$touch();
      if (this.$v.dataInput.lotSize.$invalid) {
        this.submitStatus = "ERROR";
        this.handleInvalidField("lotSize");
      } else {
        this.submitted = true;

        if (
          this.dataInput.lotSize.lotSize != "" &&
          !this.$v.dataInput.lotSize.$invalid
        ) {
          Vue.swal
            .fire({
              title: "Are you sure want to submit?",
              text: "your changes will be save!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#000000",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
            })
            .then(async (res) => {
              if (res.isConfirmed) {
                this.dismissModal();
                this.loading = true;

                let data = new FormData();

                data.append("id", this.robot.id);
                data.append("lot", this.dataInput.lotSize.lotSize);
                try {
                  await apiClient.post(
                    `${this.$route.params.id}/lot-sizes/`,
                    data
                  );
                  await this.fetchUpdateData();
                  this.submitStatus = "OK";
                  Vue.swal.fire({
                    icon: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } catch (error) {
                  this.submitStatus = "ERROR";
                  Vue.swal.fire({
                    icon: "error",
                    title: "Oops... Something went wrong! ",
                    text: `${error.data.data.lot[0]}`,
                    showConfirmButton: true,
                    confirmButtonColor: "#000000",
                  });
                } finally {
                  this.dataInput.lotSize.lotSize = "";
                  this.loading = false;
                }
              }
            });
        }
      }
    },
    async addActivePair() {
      this.$v.dataInput.activePair.$touch();
      if (this.$v.dataInput.activePair.$invalid) {
        this.submitStatus = "ERROR";
        this.handleInvalidField("activePair");
      } else {
        this.submitted = true;

        if (
          this.dataInput.activePair.pairOption != "" &&
          this.dataInput.activePair.deposit != "" &&
          !this.$v.dataInput.activePair.$invalid
        ) {
          Vue.swal
            .fire({
              title: "Are you sure want to submit?",
              text: "your changes will be save!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#000000",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
            })
            .then(async (res) => {
              if (res.isConfirmed) {
                this.dismissModal();
                this.loading = true;

                let data = new FormData();

                data.append(
                  "active_pair",
                  this.dataInput.activePair.pairOption
                );
                data.append(
                  "minimum_deposit",
                  this.dataInput.activePair.deposit
                );
                try {
                  await apiClient.post(
                    `${this.$route.params.id}/active-pairs/`,
                    data
                  );
                  await this.fetchUpdateData();
                  this.submitStatus = "OK";
                  Vue.swal.fire({
                    icon: "success",
                    title: "Data has been saved!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } catch (error) {
                  this.submitStatus = "ERROR";
                  Vue.swal.fire({
                    icon: "error",
                    title: "Oops... Something went wrong! ",
                    text: `${
                      error.data.data.symbol
                        ? error.data.data.symbol[0]
                        : error.data.data.minimum_deposit[0]
                    }`,
                    showConfirmButton: true,
                    confirmButtonColor: "#000000",
                  });
                } finally {
                  this.dataInput.activePair.pairOption = "";
                  this.dataInput.activePair.deposit = "";
                  this.loading = false;
                }
              }
            });
        }
      }
    },
    async addPairOption() {
      this.$v.dataInput.pairOption.$touch();
      if (this.$v.dataInput.pairOption.$invalid) {
        this.submitStatus = "ERROR";
        this.handleInvalidField("pairOption");
      } else {
        this.submitted = true;

        if (
          this.dataInput.pairOption.symbol != "" &&
          this.dataInput.pairOption.deposit != "" &&
          !this.$v.dataInput.pairOption.$invalid
        ) {
          Vue.swal
            .fire({
              title: "Are you sure want to submit?",
              text: "your changes will be save!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#000000",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
            })
            .then(async (res) => {
              if (res.isConfirmed) {
                this.dismissModal();
                this.loading = true;

                let data = new FormData();

                data.append("symbol", this.dataInput.pairOption.symbol);
                data.append(
                  "minimum_deposit",
                  this.dataInput.pairOption.deposit
                );
                try {
                  await apiClient.post(
                    `${this.$route.params.id}/pair-options/`,
                    data
                  );
                  await this.fetchUpdateData();
                  this.submitStatus = "OK";
                  Vue.swal.fire({
                    icon: "success",
                    title: "Data has been saved!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } catch (error) {
                  this.submitStatus = "ERROR";
                  Vue.swal.fire({
                    icon: "error",
                    title: "Oops... Something went wrong! ",
                    text: `${
                      error.data.data.symbol
                        ? error.data.data.symbol[0]
                        : error.data.data.minimum_deposit[0]
                    }`,
                    showConfirmButton: true,
                    confirmButtonColor: "#000000",
                  });
                } finally {
                  this.dataInput.pairOption.symbol = "";
                  this.dataInput.pairOption.deposit = "";
                  this.loading = false;
                }
              }
            });
        }
      }
    },
    handleInvalidField(params) {
      let invalidFields = [];
      // Define a mapping of validation fields to their display names
      const fieldNamesLotSize = {
        lotSize: "Lot Size",
      };
      const fieldNamesActivePairs = {
        pairOption: "Pair Option",
        deposit: "Deposit",
      };
      const fieldNamesPairOptions = {
        symbol: "Symbol",
        deposit: "Deposit",
      };

      // Iterate through the validations for the specific section
      for (let field in this.$v.dataInput[params]) {
        if (this.$v.dataInput[params][field].$invalid) {
          invalidFields.push(
            params === "lotSize"
              ? fieldNamesLotSize[field]
              : params === "activePair"
              ? fieldNamesActivePairs[field]
              : fieldNamesPairOptions[field]
          );
        }
      }

      // Construct the alert message
      let alertMessage = `Please correctly fill out the following : \n ${invalidFields.join(
        ", "
      )}`;

      // Show the alert with the invalid fields
      Vue.swal({
        icon: "error",
        title: "Oops...",
        text: alertMessage,
      });
    },
    async deleteLotSize(data) {
      this.submitted = true;

      Vue.swal
        .fire({
          title: "Are you sure want to delete this Lot Size?",
          text: `Lot Size ${data}% will be deleted!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#000000",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        })
        .then(async (res) => {
          if (res.isConfirmed) {
            this.loading = true;
            let newData = this.recommendedData.lotSize.filter(
              (item) => item.lot == data
            );
            let mapData = newData.map((item) => item.id);

            try {
              apiClient.delete(
                `${this.$route.params.id}/lot-sizes/${mapData}/`
              );
              await this.fetchUpdateData();
              Vue.swal.fire({
                icon: "success",
                title: "Data has been deleted!",
                showConfirmButton: false,
                timer: 1500,
              });
            } catch (error) {
              Vue.swal.fire({
                icon: "error",
                title: "Oops... Something went wrong! ",
                text: `${error.message}`,
                showConfirmButton: true,
                confirmButtonColor: "#000000",
              });
            } finally {
              this.loading = false;
            }
          }
        });
    },
    async deleteActivePair(data) {
      Vue.swal
        .fire({
          title: "Are you sure want to delete this Pair Option?",
          text: `Active Pair ${data} will be deleted!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#000000",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        })
        .then(async (res) => {
          if (res.isConfirmed) {
            this.loading = true;
            let newData = this.recommendedData.activePair.filter(
              (item) => item.active_pair == data
            );
            let mapData = newData.map((item) => item.id);

            try {
              apiClient.delete(
                `${this.$route.params.id}/active-pairs/${mapData}/`
              );
              await this.fetchUpdateData();
              Vue.swal.fire({
                icon: "success",
                title: "Data has been deleted!",
                showConfirmButton: false,
                timer: 1500,
              });
            } catch (error) {
              Vue.swal.fire({
                icon: "error",
                title: "Oops... Something went wrong! ",
                text: `${error.message}`,
                showConfirmButton: true,
                confirmButtonColor: "#000000",
              });
            } finally {
              this.loading = false;
            }
          }
        });
    },
    async deletePairOption(data) {
      this.submitted = true;

      Vue.swal
        .fire({
          title: "Are you sure want to delete this Pair Option?",
          text: `Pair Option ${data} will be deleted!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#000000",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        })
        .then(async (res) => {
          if (res.isConfirmed) {
            this.loading = true;
            let newData = this.recommendedData.pairOption.filter(
              (item) => item.symbol == data
            );
            let mapData = newData.map((item) => item.id);

            try {
              apiClient.delete(
                `${this.$route.params.id}/pair-options/${mapData}/`
              );
              await this.fetchUpdateData();
              Vue.swal.fire({
                icon: "success",
                title: "Data has been deleted!",
                showConfirmButton: false,
                timer: 1500,
              });
            } catch (error) {
              Vue.swal.fire({
                icon: "error",
                title: "Oops... Something went wrong! ",
                text: `${error.message}`,
                showConfirmButton: true,
                confirmButtonColor: "#000000",
              });
            } finally {
              this.loading = false;
            }
          }
        });
    },
    onFiltered(items) {
      this.table.totalRows = items.length;
      this.table.currentPage = 1;
    },
    brokerdetail(data) {
      this.brokerdata = data;
    },
    sendBroker(data, event) {
      if (event) {
        this.listbroker.push(data);
      } else {
        this.listbroker.forEach((databroker, index) => {
          if (databroker == data) {
            this.listbroker.splice(index, 1);
          }
        });
      }
    },
    toggleBrokerSelection(brokerID, isChecked){
      if(isChecked){
        if(!this.selectedBrokers.includes(brokerID)){
            this.selectedBrokers.push(brokerID)
        }
        return
      }

      if(this.selectedBrokers.includes(brokerID)){
        this.selectedBrokers.pop(brokerID)
      }
      return
    },
    async saveBrokerSelection(){
      let confirmed = await swal("Are you sure you want to save this broker choice?", "", "info", {
        buttons: ["Cancel", "Yes"],
      })

      if(!confirmed){return;}

      let brokerSelectionData = {
        'robot_id': this.$route.params.id,
        'broker_id': this.selectedBrokers,
        'is_active': true
      }
      try{
        let apiResponse = await apiClient.post("broker/", brokerSelectionData)

        if(apiResponse.data.success){
          Vue.swal.fire({
            icon: "success",
            title: apiResponse.data.message??"Broker choice has been saved.",
            showConfirmButton: false,
            timer: 1500,
          });
        }

      }catch(error){
        Vue.swal.fire({
          icon: "error",
          title: `Failed saving broker choice.\n[${error.data.status}]`,
          showConfirmButton: false,
          timer: 2000,
        });
      }


    },
    handleCreateData() {
      swal("Are you sure you want to save this broker choice?", "", "info", {
        buttons: ["Cancel", "Yes"],
      }).then((res) => {
        if (res) {
          this.listbroker.forEach((databroker) => {
            let data = new FormData();

            data.append("robot_id", this.$route.params.id);
            data.append("broker_id", parseInt(databroker));
            // data.append("account_number", this.payload.account_number);
            // data.append("trader_password", this.payload.trader_password);
            // data.append("broker_server", this.payload.broker_server);
            data.append("is_active", true);

            // this.$v.$touch();
            // if (this.$v.$invalid) {
            //   this.submitStatus = "ERROR";
            // } else {
            //   this.submitStatus = "PENDING";

            try {
              apiClient.post("broker/", data);
              this.submitStatus = "OK";
              this.account_number_error = "";

              this.$swal("Added!", "New data has been added.", "success").then(
                () => {}
              );
            } catch (error) {
              this.submitStatus = "ERROR";
              this.account_number_error = error.data.data.account_number[0];
            }
          });
        }
      });
    },
    dismissModal() {
      // Use jQuery to hide the modal
      $("#modalInput").modal("hide");
    },
    closeModal() {
      this.dismissModal();
      this.dataInput.activePair.pairOption = "";
      this.dataInput.activePair.deposit = "";
      this.dataInput.pairOption.symbol = "";
      this.dataInput.pairOption.deposit = "";
      this.dataInput.lotSize.lotSize = "";
    },
    UpdateData() {
        Vue.swal
        .fire({
          title: "Are you sure you want to save this broker choice?",
          text: "your changes will be save!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#000000",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then((res) => {
        if (res) {
          // let newdata = this.listbroker.filter(
          //   (ar) => !this.brokercheck.find((rm) => rm.broker_id === ar)
          // );
          let datahapus = this.brokercheck.filter((ar) =>
            !this.listbroker.find((rm) => ar.broker_id === rm)
          );
          let databaru = this.listbroker.filter(
            (ar) => !this.brokerActivedata.find((rm) => rm === ar)
          );
          // console.log(newdata);
          // console.log(datahapus);
          // console.log(databaru);
          // console.log(this.brokercheck);
          // console.log(this.listbroker);
          databaru.forEach((itemdata) => {
            let data = new FormData();
            data.append("robot_id", this.$route.params.id);
            data.append("broker_id", parseInt(itemdata));
            data.append("is_active", true);
            try {
              apiClient.post("broker/", data);
              this.submitStatus = "OK";
              this.account_number_error = "";

              Vue.swal.fire({
                icon: "success",
                title: "Data has been saved!",
                showConfirmButton: false,
                timer: 1500,
              });
            } catch (error) {
              this.submitStatus = "ERROR";
              this.account_number_error = error.data.data.account_number[0];
            }
          });
          datahapus.forEach((hapus) => {
          let data = new FormData();
          data.append("robot_id", this.$route.params.id);
          data.append("broker_id", parseInt(hapus.broker_id));
          data.append("is_active", true);
          try {
            apiClient.delete("broker/"+hapus.id, data);
            this.submitStatus = "OK";
            this.account_number_error = "";

            Vue.swal.fire({
                icon: "success",
                title: "New data has been delete!",
                showConfirmButton: false,
                timer: 1500,
            })
            .then(
              () => {
              }
            );
          } catch (error) {
            this.submitStatus = "ERROR";
            this.account_number_error = error.data.data.account_number[0];
          }
          })
        }
      });
    }

  },
  validations: {
    dataInput: {
      lotSize: {
        lotSize: {
          required,
          numeric,
        },
      },
      activePair: {
        pairOption: {
          required,
        },
        deposit: {
          required,
          numeric,
        },
      },
      pairOption: {
        symbol: {
          required,
          maxLength: maxLength(10),
        },
        deposit: {
          required,
          numeric,
          minValue: minValue(1),
        },
      },
    },
  },
};
</script>

<style scoped>
.linkbroker {
  text-align: center !important;
  background-color: transparent !important;
  font-size: 0.9rem;
  border: 0px !important;
  width: 100% !important;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  text-decoration: underline !important;
  color: rgba(0, 0, 0, 0.6) !important;
  font-weight: 400;
}
.style-badge {
  font-size: 14px;
}
.headdetailbroker figure {
  max-width: 70px;
  height: max-content;
}
.headdetailbroker figure img {
  width: 100%;
  height: 100%;
}
.headdetailbroker small {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
  font-size: 0.7rem !important;
}
.deskripsi-head {
  padding-left: 15px;
}
.deskripsi-head h5 {
  margin-bottom: 0px !important;
  font-weight: 600;
}
.headdetailbroker p,
.modalbroker p {
  margin-bottom: 0px !important;
  font-weight: 500;
  overflow: hidden !important;
}
.bottommodal {
  justify-content: space-between;
  display: flex;
}
.bottommodal > .btn_grey {
  padding: 0.375rem 0.75rem !important;
}
.bottommodal small {
  padding-top: 10px;
  font-weight: 600;
}
.broker .broker-list input[type="checkbox"] {
  display: none;
}
.broker .broker-list input:checked ~ label.broker-body {
  border: 3px solid red !important;
}
.broker .broker-list input:checked ~ label.broker-body .check_img {
  display: block;
}
.broker .broker-list {
  text-decoration: none;
  color: var(--dark-grey);
}
.broker a.broker-list:hover > .broker-body {
  border: 3px solid var(--red);
}
.broker .broker-list .broker-body {
  border: 3px solid rgb(168, 168, 168) !important;
  background: white;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s ease;
  width: 100%;
  height: 160px;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.1);
}
.broker .broker-list .broker-body .check_img {
  position: absolute;
  top: 0;
  right: 0;
  background: white;
  padding: 6px;
  border-radius: 0 10px 0 10px;
  display: none;
  z-index: 3;
  transition: all 0.3s ease;
}
.broker .broker-list .broker-body figure {
  width: 100%;
  height: 80px;
  margin-bottom: 5px;
}
.broker .broker-list .broker-body p {
  margin: 0;
  font-size: 11pt;
  max-height: 50px;
  overflow-y: scroll;
}

.broker .broker-list .broker-body p::-webkit-scrollbar {
  width: 4px;
}
.broker .broker-list .broker-body p::-webkit-scrollbar-track {
  box-shadow: inset 0 0 4px grey;
  border-radius: 5px;
}
.broker .broker-list .broker-body p::-webkit-scrollbar-thumb {
  background: #c9c9c9;
  border-radius: 5px;
}
.broker .broker-list .broker-body p::-webkit-scrollbar-thumb:hover {
  background: #797979;
}

.broker .broker-list .broker-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin: 0;
  border-radius: 5px;
}
@media only screen and (max-width: 767.9px) {
  .info-detail {
    text-align: center;
    padding-top: 1rem;
  }
}
@media only screen and (max-width: 601px) {
  .card-header {
    flex-direction: column;
    align-items: center;
  }
  .add-button {
    width: 100%;
    margin-bottom: 0.75rem;
  }
  .input-search {
    width: 100% !important;
  }
  .filter-container {
    width: 100%;
    flex-direction: column !important;
  }
  .search-bar,
  .select-perpage {
    margin-bottom: 0.75rem;
    width: 100% !important;
  }
}
.detail-image {
  --size: 250px;
  border-radius: 100vh;
  width: var(--size);
  height: var(--size);
}

.info-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem !important;
}
.card-header {
  /* display: flex; */
  justify-content: space-between;
}
.card-header::after {
  display: none !important;
  content: "";
}
.input-search {
  width: 250px;
}
.card-container {
  overflow-x: scroll; /* Enable horizontal overflow scrolling */
  max-width: 100%; /* Optional: Adjust the maximum width of the container */
  /* Hide the scrollbar in Firefox */
  /*scrollbar-width: none; */
}
.card-container::-webkit-scrollbar {
  height: 5px; /* Set the width of the vertical scrollbar */
}
.card-container::-webkit-scrollbar-thumb {
  background: #000; /* Background of the scrollbar track */
}

.card-res {
  flex: 0 0 auto; /* Prevent cards from growing */
}

@media (max-width: 768px) {
  .card-res {
    width: 100%;
  }
}
</style>
